import { CREATE, DELETE, GET_LIST, GET_ONE, UPDATE } from '@/api/types';
/** 各actionのmetaで共通の値 */
const defaultMeta = {
    cancelPrevious: false,
    isSnakeCase: false,
    requestPayload: {},
};
/**
 * 一覧取得
 * @param type
 * @param apiPath
 * @param params
 * @param meta
 * @returns {{payload: {params}, meta: (*&{cancelPrevious: boolean, apiPath, fetch: string, type}), type}}
 */
export const apiGetList = (type, apiPath, params, meta) => ({
    meta: Object.assign(Object.assign(Object.assign({}, defaultMeta), meta), { apiPath, fetch: GET_LIST, type }),
    payload: {
        params,
    },
    type,
});
/**
 * 単体取得
 * @param type
 * @param apiPath
 * @param meta
 * @returns {{payload: {}, meta: (*&{cancelPrevious: boolean, apiPath, fetch: string, type}), type}}
 */
export const apiGetOne = (type, apiPath, meta) => ({
    meta: Object.assign(Object.assign(Object.assign({}, defaultMeta), meta), { apiPath, fetch: GET_ONE, type }),
    payload: {},
    type,
});
/**
 * 作成
 * @param type
 * @param apiPath
 * @param data
 * @param meta
 * @returns {{payload: {data}, meta: (*&{cancelPrevious: boolean, apiPath, fetch: string, type}), type}}
 */
export const apiCreate = (type, apiPath, data, meta) => ({
    meta: Object.assign(Object.assign(Object.assign({}, defaultMeta), meta), { apiPath, fetch: CREATE, type }),
    payload: {
        data,
    },
    type,
});
/**
 * 更新
 * @param type
 * @param apiPath
 * @param data
 * @param meta
 * @returns {{payload: {data}, meta: (*&{cancelPrevious: boolean, apiPath, fetch: string, type}), type}}
 */
export const apiUpdate = (type, apiPath, data, meta) => ({
    meta: Object.assign(Object.assign(Object.assign({}, defaultMeta), meta), { apiPath, fetch: UPDATE, type }),
    payload: {
        data,
    },
    type,
});
/**
 * 削除
 * @param type
 * @param apiPath
 * @param meta
 * @returns {{payload: {}, meta: (*&{cancelPrevious: boolean, apiPath, fetch: string, type}), type}}
 */
export const apiDelete = (type, apiPath, meta) => ({
    meta: Object.assign(Object.assign(Object.assign({}, defaultMeta), meta), { apiPath, fetch: DELETE, type }),
    payload: {},
    type,
});
/**
 * S3等への直接のアップロード
 * @param type
 * @param apiPath
 * @param data
 * @param meta
 * @returns {{payload: {data}, meta: (*&{cancelPrevious: boolean, apiPath, fetch: string, type}), type}}
 */
export const apiDirectUploadCreate = (type, apiPath, data, meta) => ({
    meta: Object.assign(Object.assign(Object.assign({}, defaultMeta), meta), { apiPath, fetch: CREATE, type }),
    payload: {
        data,
    },
    type,
});
